import { Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCookie } from "typescript-cookie";
import { ISelectOption } from "../../models/utils/selectOption";
import { defaultFilterOption } from "../../utils";
import { EntInitialFilterName } from "../../models/filters/initialFilterName";
import { useGetDataOnScroll } from "../getDataOnScrollProps/useGetDataOnScrollProps";
import { useLazyGetBreedingFarmStatusListQuery } from "../../redux/api/handBooksApi/breedingFarmStatusApi";
import { EntBreedingFarmStatus } from "../../models/handBooks/breedingFarmStatus";

interface IProps {
  value?: number | null;
  onChange?: () => void;
}

const SelectFarmStatus = (props: IProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<ISelectOption[]>([]);


  const [getData] = useLazyGetBreedingFarmStatusListQuery();
  const {
    fetching,
    data,
    setData,
    setFetching,
    setFilter,
    scrollHandler,
    setCurrentPage
  } = useGetDataOnScroll<EntBreedingFarmStatus, EntInitialFilterName>({
    initialFilter: new EntInitialFilterName(),
    query: getData
  });

  useEffect(() => {
    const options = Array.from(new Set(data)).map((a) => {
      return { label: getCookie('i18next') === 'ky' ? `${a.nameKy}` : `${a.nameRu}` , value: a.id ?? '' };
    });
    setOptions(options);
  }, [data]);

  const search = (value?: string) => {
    if (!value) return;
    const filter = new EntInitialFilterName();
    filter.name = value;
    setFilter(filter);
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }
  const clear = () => {
    const filter = new EntInitialFilterName();
    filter.name = null;
    setFilter(filter);
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }

  return (
      <Select
          placeholder={t("msg.selectPlaceholder")}
          onClear={clear}
          onSearch={search}
          onPopupScroll={scrollHandler}
          loading={fetching}
          value={props.value}
          onChange={props.onChange}
          options={options}
          filterOption={defaultFilterOption}
          showSearch
          allowClear
          dropdownRender={(menu) => (
              <Spin spinning={fetching}>
                {menu}
              </Spin>
          )}
      />
  );
};

export default SelectFarmStatus;